<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet id="printable-area" class="report-paper pa-6" elevation="3">
          <div class="invoice-container">
            <div class="invoice-content">
              <table class="layout-table">
                <thead >
<!--                  <tr v-if="purchaseRequisitionData?.branch?.company?.header_image">-->
<!--                    <td colspan="100%">-->
<!--                      <img-->
<!--                        class="header-image"-->
<!--                        :src="fileUrl(purchaseRequisitionData.branch.company.header_image)"-->
<!--                        alt="Company header"-->
<!--                      >-->
<!--                    </td>-->
<!--                  </tr>-->

                  <tr v-if="invoiceHeader">
                    <td colspan="100%">
                      <div>
                        <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                          <img
                              :src="`${getFileServerUrl}${purchaseRequisitionData?.branch?.company?.logo}`"
                              class="logo-img"
                              alt="Logo"
                              style="max-height: 80px;"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td class="details-table" colspan="100%">
                      <div class="document-heading">PURCHASE REQUISITION</div>
                      <div class="meta-box">
                        <div class="meta-row">
                          <div><strong>Requisition No:</strong> {{ purchaseRequisitionData?.code || "-" }}</div>
                          <div><strong>Requisition Type:</strong> {{ getRequisitionType(purchaseRequisitionData?.requisition_type) }}</div>
                        </div>
                        <div class="meta-row">
                          <div><strong>Requisition Date:</strong> {{ formatDate(purchaseRequisitionData?.requisition_date) }}</div>
                          <div><strong>Require Date:</strong> {{ formatDate(purchaseRequisitionData?.require_date) }}</div>
                        </div>
                        <div class="meta-row">
                          <div><strong>Warehouse:</strong> {{ purchaseRequisitionData?.warehouse?.name || "-" }}</div>
                          <div><strong>Department:</strong> {{ purchaseRequisitionData?.department?.name || "-" }}</div>
                        </div>
                        <div class="meta-row">
                          <div><strong>Purpose/Project:</strong> {{ purchaseRequisitionData?.purpose?.name || "-" }}</div>
                          <div><strong>Approval Status:</strong> {{ purchaseRequisitionData?.approval_status || "-" }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                        <tr>
                          <th style="display:flex; justify-content: start; margin-bottom: 4px; border:none; padding: 3px">
                            Item Details
                          </th>
                        </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%">
                      <table class="details-table">
                        <thead>
                          <tr>
                            <th style="width: 7%">SL</th>
                            <th style="width: 15%">Code</th>
                            <th>Product Name</th>
                            <th style="width: 12%">Unit</th>
                            <th style="width: 15%">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(detail, index) in purchaseRequisitionData?.requisition_details || []"
                            :key="detail.id || index"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td class="text-center">{{ detail.product?.code || "-" }}</td>
                            <td>{{ detail.product?.name || "-" }}<span v-if="detail.remarks"> / {{ detail.remarks }}</span></td>
                            <td class="text-center">{{ detail.product?.unit?.name || "-" }}</td>
                            <td class="text-right">{{ formatNumber(detail.qty) }}</td>
                          </tr>
                          <tr v-if="!purchaseRequisitionData?.requisition_details?.length">
                            <td colspan="5" class="text-center">No items found</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="3"></td>
                            <td class="text-right"><strong>Total Items</strong></td>
                            <td class="text-right"><strong>{{ purchaseRequisitionData?.total_item || 0 }}</strong></td>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%" class="details-table">
                      <div v-if="purchaseRequisitionData?.remarks" class="remarks">
                        <strong>Remarks:</strong>
                        <span v-html="purchaseRequisitionData.remarks"></span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%">
                      <div class="signature-row">
                        <div class="signature-box">Prepared &amp; Issued By</div>
                        <div class="signature-box">Authorized Signatory</div>
                        <div class="signature-box">Received &amp; Accepted By</div>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot v-if="invoiceHeader">
                  <tr>
                    <td colspan="100%"><div class="footer-space"></div></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="purchaseRequisitionData?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${purchaseRequisitionData?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;"> -->
              <div class="invoice-footer" v-if="invoiceHeader" style="margin-left:10px; margin-bottom:10px; color: #343591;">
                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                  </svg>

                  <span>{{ purchaseRequisitionData?.branch?.company?.address }}</span>
                </p>

                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                  </svg>

                  <strong>Phone: </strong>  +880 9610-993393, +880 2 222288648, www.remexingredient.com | www.remexcorp.com
                </p>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="center" class="d-print-none mt-4">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">Print without pad</v-btn>
      <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">Print with pad</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { formatDateView } from "@/plugins/helpers";
import html2pdf from "html2pdf.js";

export default {
  name: "PurchaseRequisitionInvoice",

  data: () => ({
    mainId: null,
    purchaseRequisitionData: null,
    invoiceHeader: true,
  }),

  computed: {
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },

  created() {
    this.mainId = this.$route.query.id;
    this.$store.dispatch("getPurRequisitionById", this.mainId).then((response) => {
      this.purchaseRequisitionData = response;
    });
  },

  methods: {
    formatDate(date) {
      return date ? formatDateView(date) : "-";
    },
    formatDateTime(dateTime) {
      if (!dateTime) return "-";
      return `${this.formatDate(dateTime)} ${new Date(dateTime).toLocaleTimeString()}`;
    },
    formatNumber(value) {
      return Number(value || 0).toFixed(2);
    },
    getRequisitionType(type) {
      return type === "with_cs" ? "With CS" : type === "without_cs" ? "Without CS" : type || "-";
    },
    print(withPad) {
      this.invoiceHeader = Boolean(withPad);
      setTimeout(() => {
        const printContent = document.getElementById("printable-area").innerHTML;
        const printWindow = window.open("", "_blank", `width=${screen.width},height=${screen.height}`);
        printWindow.document.write(`
          <!doctype html>
          <html>
            <head>
              <meta charset="UTF-8">
              <title>Purchase Requisition</title>
              <style>
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                  }
                    @page { size: A4; margin: ${withPad ? "0" : "100px 0"}; }
                    html, body {
                    margin: 0 ;
                    padding: 0;
                    width: 100%;
                    height: auto;
                  }
                body { font-family: Arial, sans-serif; color: #000; background: #fff; }
                .report-paper { width: 100%; padding: 0 24px; }
                .layout-table, .details-table { width: 100%; border-collapse: collapse; }
                .details-table { padding: 0px 32px; }
                .header-image, .footer-image { width: 100%; display: block; }
                .company-header { display: flex; justify-content: space-between; border-bottom: 2px solid #eee; padding: 12px 0; }
                .company-name { font-size: 16px; font-weight: bold; text-transform: uppercase; }
                .company-text { font-size: 11px; margin-top: 4px; }
                .logo-img { max-width: 150px; max-height: 70px; object-fit: contain; }
                .document-heading { text-align: center; font-size: 16px; font-weight: bold; text-decoration: underline; margin: 14px 0; }
                .meta-box { border: 1px solid #000; margin-bottom: 16px; }
                .meta-row { display: flex; }
                .meta-row > div { width: 50%; min-height: 28px; padding: 7px; border-bottom: 1px solid #000; font-size: 11px; }
                .meta-row > div + div { border-left: 1px solid #000; }
                .meta-row:last-child > div { border-bottom: 0; }
                .section-title { font-weight: bold; font-size: 12px; margin-bottom: 4px; }
                .details-table th, .details-table td { border: 1px solid #d8d8d8; padding: 5px; font-size: 11px; }
                .details-table th { background: #e8e8e8; text-align: center; }
                .text-center { text-align: center; } .text-right { text-align: right; }
                .remarks, .prepared-by { font-size: 11px; margin-top: 14px; }
                .prepared-by span { color: #666; }
                .signature-row { display: flex; justify-content: space-between; margin-top: 55px; }
                .signature-box { width: 28%; border-top: 1px solid #000; padding-top: 6px; text-align: center; font-size: 11px; font-weight: bold; }
                .footer-space { height: 70px; }
                .invoice-footer {
                    margin-top: auto;
                    position: fixed;
                    left: 0;
                    bottom: 0px;
                    width: 100%;
                  }
              </style>
            </head>
            <body>${printContent}</body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
          printWindow.print();
          printWindow.onafterprint = () => printWindow.close();
          this.invoiceHeader = true;
        }, 500);
      }, 100);
    },
  },
};
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: #fff; color: #000; }
.layout-table { width: 100%; border-collapse: collapse; }
.header-image, .footer-image { width: 100%; display: block; }
.company-header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #eee; padding: 12px 0; }
.company-name { font-size: 16px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 12px; margin-top: 4px; }
.logo-img { max-width: 150px; max-height: 70px; object-fit: contain; }
.document-heading { text-align: center; font-size: 18px; font-weight: bold; text-decoration: underline; margin: 18px 0; }
.meta-box { border: 1px solid #000; margin-bottom: 18px; }
.meta-row { display: flex; }
.meta-row > div { width: 50%; min-height: 34px; padding: 9px; border-bottom: 1px solid #000; font-size: 12px; }
.meta-row > div + div { border-left: 1px solid #000; }
.meta-row:last-child > div { border-bottom: 0; }
.section-title { font-size: 13px; font-weight: bold; margin-bottom: 5px; }
.details-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.details-table th, .details-table td { border: 1px solid #d8d8d8; padding: 6px; }
.details-table th { background: #e8e8e8; text-align: center; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.remarks, .prepared-by { font-size: 12px; margin-top: 16px; }
.prepared-by span { color: #666; }
.signature-row { display: flex; justify-content: space-between; margin-top: 70px; }
.signature-box { width: 28%; border-top: 1px solid #000; padding-top: 7px; text-align: center; font-size: 12px; font-weight: bold; }
@media print {
  .report-paper { box-shadow: none !important; }
}
</style>
